import { render, staticRenderFns } from "./listagemViagens.vue?vue&type=template&id=79b9a95c&scoped=true"
import script from "./listagemViagens.vue?vue&type=script&lang=js"
export * from "./listagemViagens.vue?vue&type=script&lang=js"
import style0 from "./listagemViagens.vue?vue&type=style&index=0&id=79b9a95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9a95c",
  null
  
)

export default component.exports